import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { ThemeProvider } from "./component/common/ThemeContext";
import ThemeToggle from "./component/common/ThemeToggle";

import "./App.css";
import "./component/styles/variables.css";
import "./component/styles/global.css";

import Home from "./component/home/home";
import About from "./component/about/about";
import Career from "./component/career/career";
import Contact from "./component/contact/contact";
import Projects from "./component/project/project";
import Services from "./component/service/service";

import MainFooter from "./component/common/mainFooter";
import Navbar from "./component/common/navbar";
import Loading from "./component/common/Loading";

function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  // 🔹 Show loader on every route change
  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 800); // adjust delay if needed

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <ThemeProvider>
      {loading && <Loading />}

      {!loading && (
        <div className="App">
          <ThemeToggle />
          <Navbar />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/career" element={<Career />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/project" element={<Projects />} />
            <Route path="/service" element={<Services />} />
          </Routes>

          <MainFooter />
        </div>
      )}
    </ThemeProvider>
  );
}

export default App;
